<!-- Modern Financial Header -->
<header class="modern-header">
  <!-- Container Principal -->
  <div class="header-container">
    
    <!-- Logo Section -->
    <div class="logo-section" (click)="goHome()">
      <img src="/assets/images/logo_white.svg" alt="logo" class="brand-logo">
    </div>

    <!-- Navigation Icons (Desktop) -->
    <nav class="platform-navigation" *ngIf="isMultiplatform && !hideMediasIcon">
      <div class="nav-items">
        <button 
          *ngIf="walletEnabled" 
          (click)="navigateTo('/home')" 
          [class.active]="currentPlatform === platform.WALLET"
          class="nav-item"
          [matTooltip]="'header.menuUser.digitalWallet' | translate"
          matTooltipPosition="below">
          <mat-icon>account_balance_wallet</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.digitalWallet' | translate }}</span>
        </button>

        <button 
          *ngIf="digitalBankingEnabled" 
          (click)="navigateTo('/digital-banking')" 
          [class.active]="currentPlatform === platform.BANKING"
          class="nav-item"
          [matTooltip]="'header.menuUser.digitalBanking' | translate"
          matTooltipPosition="below">
          <mat-icon>payments</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.digitalBanking' | translate }}</span>
        </button>

        <button 
          *ngIf="marketplaceEnabled" 
          (click)="navigateTo('/marketplace')" 
          [class.active]="currentPlatform === platform.MARKETPLACE"
          class="nav-item"
          [matTooltip]="'header.menuUser.marketplace' | translate"
          matTooltipPosition="below">
          <mat-icon>store</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.marketplace' | translate }}</span>
        </button>

        <button 
          *ngIf="exchangeEnabled" 
          (click)="navigateTo('/exchange')" 
          [class.active]="currentPlatform === platform.EXCHANGE"
          class="nav-item"
          [matTooltip]="'header.menuUser.exchange' | translate"
          matTooltipPosition="below">
          <mat-icon>swap_horiz</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.exchange' | translate }}</span>
        </button>

        <button 
          *ngIf="tokenizationEnabled" 
          (click)="navigateTo('/tokenization')" 
          [class.active]="currentPlatform === platform.TOKENIZATION"
          class="nav-item"
          [matTooltip]="'header.menuUser.tokenization' | translate"
          matTooltipPosition="below">
          <mat-icon>assessment</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.tokenization' | translate }}</span>
        </button>

        <button 
          *ngIf="crowdfundingEnabled" 
          (click)="navigateTo('/tokenization/crowdfunding')" 
          [class.active]="currentPlatform === platform.CROWDFUNDING"
          class="nav-item"
          [matTooltip]="'header.menuUser.crowdfunding' | translate"
          matTooltipPosition="below">
          <mat-icon>business</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.crowdfunding' | translate }}</span>
        </button>

        <button 
          *ngIf="chatEnabled" 
          (click)="navigateTo('/chat')" 
          [class.active]="currentPlatform === platform.CHAT"
          class="nav-item"
          [matTooltip]="'header.menuUser.chat' | translate"
          matTooltipPosition="below">
          <mat-icon>forum</mat-icon>
          <span class="nav-label">{{ 'header.menuUser.chat' | translate }}</span>
        </button>
      </div>
    </nav>

    <!-- User Actions Section -->
    <div class="user-actions">
      
      <!-- More Menu -->
      <button class="action-button" [matMenuTriggerFor]="moreMenu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <!-- User Menu -->
      <button class="user-profile-button" [matMenuTriggerFor]="userMenu">
        <div class="user-avatar">
          <mat-icon>account_circle</mat-icon>
        </div>
        <div class="user-info" *ngIf="loggedUser?.firstName">
          <span class="user-name">{{ loggedUser?.firstName }}</span>
          <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <!-- Mobile Menu Toggle -->
      <button 
        class="mobile-menu-toggle" 
        (click)="toggleSidenav()" 
        *ngIf="!hideSidebarIcon && currentPlatform === platform.WALLET">
        <mat-icon>menu</mat-icon>
      </button>

    </div>
  </div>

  <!-- Loading Bar -->
  <div class="loading-bar" *ngIf="loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</header>

<!-- ==================== More Menu ==================== -->
<mat-menu #moreMenu="matMenu" class="modern-menu more-menu" xPosition="before">
  <div class="menu-section">
    <h4 class="menu-section-title">{{ 'header.contacts.aboutCompany' | translate }}</h4>
    
    <button mat-menu-item (click)="goToUrl('aboutUs')" class="menu-item-modern">
      <mat-icon>info</mat-icon>
      <span>{{ 'header.contacts.aboutCompany' | translate }}</span>
    </button>

    <button mat-menu-item (click)="goToUrl('policies/privacy')" class="menu-item-modern">
      <mat-icon>privacy_tip</mat-icon>
      <span>{{ 'header.contacts.privacyPolicy' | translate }}</span>
    </button>

    <button mat-menu-item (click)="goToUrl('policies/terms')" *ngIf="crowdfundingEnabled" class="menu-item-modern">
      <mat-icon>gavel</mat-icon>
      <span>{{ 'footer.terms' | translate }}</span>
    </button>

    <button mat-menu-item (click)="goToUrl('policies/material')" *ngIf="crowdfundingEnabled" class="menu-item-modern">
      <mat-icon>inventory_2</mat-icon>
      <span>{{ 'footer.material' | translate }}</span>
    </button>

    <button mat-menu-item (click)="goToUrl('policies/code')" *ngIf="crowdfundingEnabled" class="menu-item-modern">
      <mat-icon>code</mat-icon>
      <span>{{ 'footer.code' | translate }}</span>
    </button>

    <button *ngIf="externalLinks?.faq" mat-menu-item (click)="goToUrl('faq')" class="menu-item-modern">
      <mat-icon>help_outline</mat-icon>
      <span>{{ 'header.contacts.faq' | translate }}</span>
    </button>

    <button mat-menu-item (click)="goToContact()" class="menu-item-modern">
      <mat-icon>contact_support</mat-icon>
      <span>{{ 'header.contacts.contact' | translate }}</span>
    </button>

    <button mat-menu-item (click)="goToDelete()" class="menu-item-modern delete-action">
      <mat-icon>delete_outline</mat-icon>
      <span>{{ 'header.contacts.exclude' | translate }}</span>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="menu-section social-section">
    <h4 class="menu-section-title">{{ 'header.contacts.socialNetworks' | translate }}</h4>
    <div class="social-links">
      <button 
        *ngFor="let socialMedia of socialMedias" 
        mat-menu-item 
        (click)="goToUrl('socialMidias/' + socialMedia)"
        class="social-link menu-item-modern">
        <img [src]="'/assets/images/' + socialMedia + '.svg'" [alt]="socialMedia" class="social-icon">
        <span>{{ 'header.contacts.' + socialMedia | translate }}</span>
      </button>
    </div>
  </div>
</mat-menu>

<!-- ==================== User Menu ==================== -->
<mat-menu #userMenu="matMenu" class="modern-menu user-menu" xPosition="before">
  
  <section *ngIf="loggedUser?.firstName">
    
    <!-- User Info Header -->
    <div class="user-menu-header">
      <div class="user-avatar-large">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="user-details">
        <span class="user-full-name">{{ loggedUser?.firstName }}</span>
        <span class="user-email">{{ loggedUser?.email }}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Platform Navigation (Mobile) -->
    <div class="menu-section platform-section" *ngIf="hideMediasIcon && (digitalBankingEnabled || marketplaceEnabled || tokenizationEnabled)">
      <h4 class="menu-section-title">{{ 'header.menuUser.platforms' | translate }}</h4>
      
      <button *ngIf="walletEnabled" mat-menu-item routerLink="/home" [disabled]="currentPlatform === platform.WALLET" class="menu-item-modern">
        <mat-icon>account_balance_wallet</mat-icon>
        <span>{{ 'header.menuUser.digitalWallet' | translate }}</span>
      </button>

      <button *ngIf="digitalBankingEnabled" mat-menu-item routerLink="/digital-banking" [disabled]="currentPlatform === platform.BANKING" class="menu-item-modern">
        <mat-icon>payments</mat-icon>
        <span>{{ 'header.menuUser.digitalBanking' | translate }}</span>
      </button>

      <button *ngIf="marketplaceEnabled" mat-menu-item routerLink="/marketplace" [disabled]="currentPlatform === platform.MARKETPLACE" class="menu-item-modern">
        <mat-icon>store</mat-icon>
        <span>{{ 'header.menuUser.marketplace' | translate }}</span>
      </button>

      <button *ngIf="exchangeEnabled" mat-menu-item routerLink="/exchange" [disabled]="currentPlatform === platform.EXCHANGE" class="menu-item-modern">
        <mat-icon>swap_horiz</mat-icon>
        <span>{{ 'header.menuUser.exchange' | translate }}</span>
      </button>

      <button *ngIf="tokenizationEnabled" mat-menu-item routerLink="/tokenization" [disabled]="currentPlatform === platform.TOKENIZATION" class="menu-item-modern">
        <mat-icon>assessment</mat-icon>
        <span>{{ 'header.menuUser.tokenization' | translate }}</span>
      </button>

      <button *ngIf="crowdfundingEnabled" mat-menu-item routerLink="/tokenization/crowdfunding" [disabled]="currentPlatform === platform.CROWDFUNDING" class="menu-item-modern">
        <mat-icon>business</mat-icon>
        <span>{{ 'header.menuUser.crowdfunding' | translate }}</span>
      </button>

      <button *ngIf="chatEnabled" mat-menu-item routerLink="/chat" [disabled]="currentPlatform === platform.CHAT" class="menu-item-modern">
        <mat-icon>forum</mat-icon>
        <span>{{ 'header.menuUser.chat' | translate }}</span>
      </button>

      <mat-divider></mat-divider>
    </div>

    <!-- Account Settings -->
    <div class="menu-section">
      <button mat-menu-item routerLink="/profile" class="menu-item-modern">
        <mat-icon>person</mat-icon>
        <span>{{ 'header.menuUser.myProfile' | translate }}</span>
      </button>

      <button mat-menu-item routerLink="/account/forgot" class="menu-item-modern">
        <mat-icon>lock_reset</mat-icon>
        <span>{{ 'header.menuUser.changePassword' | translate }}</span>
      </button>

      <button mat-menu-item (click)="toggleTheme()" class="menu-item-modern">
        <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
        <span>{{ isDarkMode ? ('header.mode.light' | translate) : ('header.mode.dark' | translate) }}</span>
      </button>
    </div>

    <mat-divider></mat-divider>

    <!-- Language Selection -->
    <div class="menu-section language-section">
      <h4 class="menu-section-title">{{ 'header.language.title' | translate }}</h4>
      
      <button mat-menu-item (click)="setLanguage('pt-br')" class="menu-item-modern language-item">
        <img src="./assets/flagIcons/br_flag.svg" alt="flag" class="flag-icon">
        <span>{{ 'header.language.portuguese' | translate }}</span>
      </button>

      <button mat-menu-item (click)="setLanguage('es')" class="menu-item-modern language-item">
        <img src="./assets/flagIcons/spa_flag.svg" alt="flag" class="flag-icon">
        <span>{{ 'header.language.spanish' | translate }}</span>
      </button>

      <button mat-menu-item (click)="setLanguage('en')" class="menu-item-modern language-item">
        <img src="./assets/flagIcons/usa_flag.svg" alt="flag" class="flag-icon">
        <span>{{ 'header.language.english' | translate }}</span>
      </button>
    </div>

    <mat-divider></mat-divider>

    <!-- Additional Features -->
    <div class="menu-section">
      <button *ngFor="let item of cards" (click)="navigateToInternalPage(item)" mat-menu-item class="menu-item-modern">
        <mat-icon>{{ item?.icon || 'credit_card' }}</mat-icon>
        <span>{{ 'home.carouselCards.' + item?.name + '.title' | translate }}</span>
      </button>

      <button *ngIf="tokenizationEnabled" mat-menu-item routerLink="/tokenization/my-assets" class="menu-item-modern">
        <mat-icon>account_balance</mat-icon>
        <span>{{ 'header.menuUser.myAssets' | translate }}</span>
      </button>

      <button *ngIf="tokenizationEnabled && paymentQueueEnabled" mat-menu-item routerLink="/tokenization/payment-history" class="menu-item-modern">
        <mat-icon>history</mat-icon>
        <span>{{ 'header.menuUser.paymentQueue' | translate }}</span>
      </button>

      <button *ngIf="externalDeposit" mat-menu-item routerLink="/navigation/invoice" class="menu-item-modern">
        <mat-icon>receipt</mat-icon>
        <span>{{ 'header.generateInvoice' | translate }}</span>
      </button>

      <button mat-menu-item routerLink="/navigation/informe-rendimentos" class="menu-item-modern">
        <mat-icon>summarize</mat-icon>
        <span>{{ 'taxReport.title' | translate }}</span>
      </button>

      <button *ngIf="crowdfundingEnabled" mat-menu-item routerLink="/tokenization/crowdfunding/my-investments" class="menu-item-modern">
        <mat-icon>trending_up</mat-icon>
        <span>{{ 'header.menuUser.myCrowdfunding' | translate }}</span>
      </button>



      <button mat-menu-item (click)="redeemReward()" class="menu-item-modern">
        <mat-icon>card_giftcard</mat-icon>
        <span>{{ 'header.menuUser.redeemReward' | translate }}</span>
      </button>

      <button *ngIf="apiEnabled" mat-menu-item routerLink="/applications" class="menu-item-modern">
        <mat-icon>api</mat-icon>
        <span>{{ 'data.application.title' | translate }}</span>
      </button>

      <button mat-menu-item (click)="copyIndication()" class="menu-item-modern">
        <mat-icon>link</mat-icon>
        <span>{{ 'header.menuUser.copyIndication' | translate }}</span>
      </button>

      <button mat-menu-item (click)="myIndications()" class="menu-item-modern">
        <mat-icon>people</mat-icon>
        <span>{{ 'friends.myIndications' | translate }}</span>
      </button>

            <!-- Credit Section -->
      <ng-container *ngIf="creditInvestmentsEnabled">
        <mat-divider></mat-divider>
        <h4 class="menu-section-title">{{ 'header.menuUser.credit.title' | translate }}</h4>
        
        <button mat-menu-item routerLink="/tokenization/credit/investor" class="menu-item-modern">
          <mat-icon>account_balance_wallet</mat-icon>
          <span>{{ 'header.menuUser.credit.investorDashboard' | translate }}</span>
        </button>
        
        <button *ngIf="isOriginator" mat-menu-item routerLink="/tokenization/credit/originator" class="menu-item-modern">
          <mat-icon>business_center</mat-icon>
          <span>{{ 'header.menuUser.credit.originatorDashboard' | translate }}</span>
        </button>
        
        <button mat-menu-item routerLink="/tokenization/credit/portfolio" class="menu-item-modern">
          <mat-icon>pie_chart</mat-icon>
          <span>{{ 'header.menuUser.credit.portfolio' | translate }}</span>
        </button>
      </ng-container>
    </div>

    <mat-divider></mat-divider>

    <!-- Logout -->
    <button mat-menu-item (click)="logout()" class="menu-item-modern logout-action">
      <mat-icon>logout</mat-icon>
      <span>{{ 'header.menuUser.logout' | translate }}</span>
    </button>

    <!-- Mobile Additional Links -->
    <div class="mobile-only-section" *ngIf="hideMediasIcon">
      <mat-divider></mat-divider>
      
      <div class="menu-section">
        <button mat-menu-item (click)="goToUrl('aboutUs')" class="menu-item-modern">
          <mat-icon>info</mat-icon>
          <span>{{ 'header.contacts.aboutCompany' | translate }}</span>
        </button>

        <button mat-menu-item (click)="goToUrl('policies/privacy')" class="menu-item-modern">
          <mat-icon>privacy_tip</mat-icon>
          <span>{{ 'header.contacts.privacyPolicy' | translate }}</span>
        </button>

        <button *ngIf="externalLinks?.faq" mat-menu-item (click)="goToUrl('faq')" class="menu-item-modern">
          <mat-icon>help_outline</mat-icon>
          <span>{{ 'header.contacts.faq' | translate }}</span>
        </button>

        <button mat-menu-item (click)="goToContact()" class="menu-item-modern">
          <mat-icon>contact_support</mat-icon>
          <span>{{ 'header.contacts.contact' | translate }}</span>
        </button>

        <button mat-menu-item (click)="goToDelete()" class="menu-item-modern delete-action">
          <mat-icon>delete_outline</mat-icon>
          <span>{{ 'header.contacts.exclude' | translate }}</span>
        </button>
        
      </div>

      <div class="menu-section social-section">
        <h4 class="menu-section-title">{{ 'header.contacts.socialNetworks' | translate }}</h4>
        <div class="social-links">
          <button 
            *ngFor="let socialMedia of socialMedias" 
            mat-menu-item 
            (click)="goToUrl('socialMidias/' + socialMedia)"
            class="social-link menu-item-modern">
            <img [src]="'/assets/images/' + socialMedia + '.svg'" [alt]="socialMedia" class="social-icon">
            <span>{{ 'header.contacts.' + socialMedia | translate }}</span>
          </button>
        </div>
      </div>
    </div>

  </section>

  <!-- Not Logged In -->
  <section *ngIf="!loggedUser?.firstName">
    <button mat-menu-item routerLink="/account/login" class="menu-item-modern">
      <mat-icon>login</mat-icon>
      <span>{{ 'header.login' | translate }}</span>
    </button>
  </section>
</mat-menu>
